import React, { Component } from 'react';
import {
    Button,
    Card,
    Col,
    Collapse,
    DatePicker, Empty,
    Form,
    message,
    Modal,
    Row,
    Select,
    Skeleton,
    Spin,
    Table,
    Tag
} from "antd";
import moment from "moment";
import {
    getFuelSummeryReport,
} from "../../../appRedux/actions/Fuel";
import { connect } from "react-redux";
import { saveAs } from 'file-saver';
import json2csv from 'json2csv';
import './style.css';

const { Panel } = Collapse;

const { RangePicker } = DatePicker;

class SummeryReport extends Component {

    state = {
        currentTimePeriod: 'daily'
    };

    componentDidMount() {
        // Set initial time period from form field
        const initialTimePeriod = this.props.form.getFieldValue('timePeriod') || 'daily';
        this.setState({ currentTimePeriod: initialTimePeriod });
    }

    handleTimePeriodChange = (value) => {
        this.setState({ currentTimePeriod: value });
    };

    handleSubmit = e => {
        e.preventDefault();
        e.stopPropagation();
        this.props.form.validateFields((err, values) => {
            if (err) {
            } else {
                if (moment(values.periodFromTo[0]).isSameOrBefore(values.periodFromTo[1])) {
                    const payload = {
                        location: values.location,
                        subLocation: values.subLocation,
                        fuelType: values.fuelType,
                        periodFrom: moment(values.periodFromTo[0]).startOf('day').toDate(),
                        periodTo: moment(values.periodFromTo[1]).endOf('day').toDate(),
                    };
                    this.props.getFuelSummeryReport(payload, values.timePeriod || 'daily')
                } else {
                    message.error("Period From couldn't come earlier than Period To!");
                }
            }
        });
    };

    expandedRowRender = (reportData) => {
        const columns = [
            {
                title: 'Date',
                dataIndex: 'date',
                key: 'date',
                render: (date) => <div>{moment(date).format('DD-MM-YYYY')}</div>
            },
            { title: 'Location', dataIndex: 'location', key: 'location' },
            { title: 'Sub Location', dataIndex: 'subLocation', key: 'subLocation' },
            {
                title: 'Fuel Type',
                dataIndex: 'fuel',
                key: 'fuel',
                render: (_, record) => record.typeOfFuel && record.typeOfFuel.name
            },
            { title: 'Quantity', dataIndex: 'quantity', key: 'quantity' },
        ];
        return <Table columns={columns} dataSource={reportData} pagination={false} />;
    }

    primaryCols = (data, timePeriod = 'daily') => {
        const getPeriodTitle = () => {
            switch (timePeriod) {
                case 'yearly':
                    return 'Year';
                case 'quarterly':
                    return 'Quarter';
                case 'monthly':
                    return 'Month';
                case 'weekly':
                    return 'Week';
                case 'daily':
                default:
                    return 'Date';
            }
        };

        return [
            {
                title: `${getPeriodTitle()} From`,
                dataIndex: 'dateFrom',
                key: 'dateFrom',
                render: (dateFrom) => {
                    // const records = record && record.records && record.records[0] && record.records[0].records || [];
                    // const from = records.length && records[0] && records[0] && records[0]['date'];
                    return <div>{dateFrom && moment(dateFrom).format('DD-MM-YYYY')}</div>
                }
            },
            {
                title: `${getPeriodTitle()} To`,
                dataIndex: 'dateTo',
                key: 'dateTo',
                render: (dateTo) => {
                    // const records = record && record.records || [];
                    // const records = record && record.records && record.records[0] && record.records[0].records || [];
                    // const to = records.length && records[records.length - 1] && records[records.length - 1] && records[records.length - 1]['date'];
                    return <div>{dateTo && moment(dateTo).format('DD-MM-YYYY')}</div>
                }
            },
            {
                title: 'Location',
                dataIndex: 'location',
                key: 'location',
                // render: (_, record) => {
                //   const location = record._id && record._id.location;
                //   return location && location.name
                // }
            },
            {
                title: 'Sub Location', dataIndex: 'subLocation', key: 'subLocation',
                // render: (_, record) => {
                //   const subLocation = record._id && record._id.subLocation;
                //   return subLocation && subLocation.name
                // }
            },
            {
                title: 'Fuel Type',
                dataIndex: 'typeOfFuel',
                key: 'typeOfFuel',
                // render: (_, record) => {
                //   const typeOfFuel = record._id && record._id.typeOfFuel;
                //   return typeOfFuel && typeOfFuel.name
                // }
            },
            {
                title: 'Quantity', dataIndex: 'quantity', key: 'quantity',
                // render: (_, record) => {
                //   // const records = record && record.records || [];
                //   const records = record && record.records && record.records[0] && record.records[0].records || [];
                //   const totalQty = records.reduce((acc, currentValue) => acc + currentValue.quantity, 0);
                //   return <div>{totalQty}</div>
                // }
            },
        ];
    }

    downloadReport = (summery_report_data) => {
        if (summery_report_data && summery_report_data.length) {
            let docs = [];
            summery_report_data.map(data => docs = docs.concat(data.children))
            // console.log(docs)
            // const uniqueMeters = [...new Set(docs.flatMap(obj => obj.meterNames))];
            // console.log(uniqueMeters)

            // Get the current time period from state
            const timePeriod = this.state.currentTimePeriod;

            let fields = [
                { label: 'Date', value: (row) => row.dateTo && moment(row.dateTo).format('DD-MM-YYYY_HH:mm:ss') },
                { label: 'Location', value: 'location' },
                { label: 'SubLocation', value: 'subLocation' },
                { label: 'Fuel Type', value: 'typeOfFuel' },
                { label: 'Quantity', value: 'quantity' },
            ];

            // Convert data to CSV format
            const csv = json2csv.parse(docs, { fields });

            // Create a Blob from the CSV data
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });

            // Save the CSV file using FileSaver.js with time period in filename
            saveAs(blob, `location-consumption-report-${timePeriod}-${new Date().getTime()}.csv`);
        }
    }

    expandedRowRender = (record) => {
        const columns = [
            {
                title: 'Date From',
                dataIndex: 'dateFrom',
                key: 'dateFrom',
                render: (_, record) => {
                    // const records = record && record.records || [];
                    const records = record && record.records || [];
                    const to = records.length && records[0] && records[0]['date'];
                    return <div>{to && moment(to).format('DD-MM-YYYY HH:mm A')}</div>
                }
            },
            {
                title: 'Date To',
                dataIndex: 'date To',
                key: 'date',
                render: (_, record) => {
                    // const records = record && record.records || [];
                    const records = record && record.records || [];
                    const to = records.length && records[records.length - 1] && records[records.length - 1]['date'];
                    return <div>{to && moment(to).format('DD-MM-YYYY HH:mm A')}</div>
                }
            },
            {
                title: 'Location',
                dataIndex: 'location',
                key: 'location',
                render: (_, record) => {
                    const location = record && record.location;
                    return location && location.name
                }
            },
            {
                title: 'Sub Location', dataIndex: 'subLocation', key: 'subLocation', render: (_, record) => {
                    const subLocation = record && record.subLocation;
                    return subLocation && subLocation.name
                }
            },
            {
                title: 'Fuel Type',
                dataIndex: 'typeOfFuel',
                key: 'typeOfFuel',
                render: (typeOfFuel) => {
                    return typeOfFuel && typeOfFuel.name
                }
            },
            {
                title: 'Quantity', dataIndex: 'quantity', key: 'quantity',
                render: (_, record) => {
                    // const records = record && record.records || [];
                    const records = record && record.records || [];
                    const totalQty = records.reduce((acc, currentValue) => acc + currentValue.quantity, 0);
                    return <div>{totalQty}</div>
                }

            },
        ];

        return <Table columns={columns} dataSource={record.records || []} pagination={false} />;
    };

    render() {

        const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;
        const { loading, summery_report_data, filters } = this.props;

        // console.log(summery_report_data)
        // Get the current time period from state
        const timePeriod = this.state.currentTimePeriod;

        return (

            <Spin spinning={loading}>
                <Card className={`gx-card-metrics`} title={`Location-Wise Fuel Consumption Report (${timePeriod.charAt(0).toUpperCase() + timePeriod.slice(1)})`}>
                    <Form
                        onSubmit={this.handleSubmit}
                        className="ant-advanced-search-form"
                        layout="inline"
                        labelAlign="left"
                    >
                        <Row>
                            <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                                <Form.Item key={'location'} label={'Location'} style={{ width: '100%' }}>
                                    {getFieldDecorator(`location`, {
                                        rules: [{ required: true, message: `Location is required!` }],
                                    })(<Select
                                        showSearch
                                        showArrow
                                        filterOption={(input, option) =>
                                            (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                        }
                                        placeholder={`Select Location`}
                                    >
                                        <Select.Option key={'AllLocation'}
                                            value={'all'}>All</Select.Option>
                                        {(this.props.authUser && this.props.authUser.locations || []).map(item =>
                                            <Select.Option key={item._id}
                                                value={item._id}>{item.name}</Select.Option>)}

                                    </Select>)
                                    }
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                                <Form.Item key={'subLocation'} label={'Sub Location'} style={{ width: '100%' }}>
                                    {getFieldDecorator(`subLocation`, {
                                        rules: [{ required: true, message: `Sub Location is required!` }],
                                    })(<Select
                                        showSearch
                                        showArrow
                                        filterOption={(input, option) =>
                                            (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                        }
                                        placeholder={`Select Sub Location`}
                                    >
                                        <Select.Option key={'AllSubLocation'}
                                            value={'all'}>All</Select.Option>
                                        {(this.props.authUser && this.props.authUser.clients || []).map(item =>
                                            <Select.Option key={item._id}
                                                value={item._id}>{item.name}</Select.Option>)}

                                    </Select>)
                                    }
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                                <Form.Item key={"fuelType"} label={`Fuel Type`} style={{ width: '100%' }}>
                                    {getFieldDecorator(`fuelType`, {
                                        rules: [
                                            {
                                                required: true,
                                                message: `Fuel Type is required!`,
                                            },
                                        ],
                                    })(
                                        <Select
                                            showSearch
                                            placeholder={`Select Fuel Type`}>
                                            <Select.Option
                                                key={"f-all"}
                                                value={"all"}
                                            >{`All`}</Select.Option>
                                            {(
                                                (filters["typeOfFuel"] &&
                                                    filters["typeOfFuel"].data.data) ||
                                                []
                                            ).map((item) => (
                                                <Select.Option key={item._id} value={item._id}>
                                                    {item.name}
                                                </Select.Option>
                                            ))}
                                        </Select>,
                                    )}
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                                <Form.Item
                                    key={"periodFromTo"}
                                    label={"Select Period"}
                                    style={{ width: "100%" }}
                                >
                                    {getFieldDecorator(`periodFromTo`, {
                                        rules: [
                                            { required: true, message: `Period From To is required!` }
                                        ],
                                        initialValue: null
                                    })(<RangePicker style={{ width: "100%" }} />)}
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                                <Form.Item key={"timePeriod"} label={`Group By`} style={{ width: '100%' }}>
                                    {getFieldDecorator(`timePeriod`, {
                                        initialValue: 'daily',
                                        rules: [
                                            {
                                                required: true,
                                                message: `Time Period is required!`,
                                            },
                                        ],
                                    })(
                                        <Select
                                            placeholder={`Select Time Period`}
                                            onChange={this.handleTimePeriodChange}>
                                            <Select.Option key={"daily"} value={"daily"}>
                                                Daily
                                            </Select.Option>
                                            <Select.Option key={"weekly"} value={"weekly"}>
                                                Weekly
                                            </Select.Option>
                                            <Select.Option key={"monthly"} value={"monthly"}>
                                                Monthly
                                            </Select.Option>
                                            <Select.Option key={"quarterly"} value={"quarterly"}>
                                                Quarterly
                                            </Select.Option>
                                            <Select.Option key={"yearly"} value={"yearly"}>
                                                Yearly
                                            </Select.Option>
                                        </Select>,
                                    )}
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                                <Form.Item style={{ marginTop: '25px' }}>
                                    <span style={{ display: 'flex', flexDirection: 'row' }}>
                                        <Button type="primary" htmlType="submit" loading={loading}>
                                            Generate Report
                                        </Button>
                                        <Button disabled={!summery_report_data || !summery_report_data.length}
                                            type="default" htmlType="button" loading={loading} icon={'download'}
                                            onClick={() => this.downloadReport(summery_report_data)}>
                                            Download
                                        </Button>
                                    </span>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>

                    {summery_report_data ?
                        <Table dataSource={summery_report_data} columns={this.primaryCols(summery_report_data, timePeriod)}
                            pagination={false} bordered expandIconColumnIndex={3}
                            /*expandedRowRender={this.expandedRowRender}*/ scroll={{ x: true }} />
                        : loading ? <Skeleton active /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                </Card>
            </Spin>
        );
    }
}

const mapStateToProps = ({ auth, fuel, commonData }) => {
    return {
        authUser: auth.authUser,
        loading: commonData.loading,
        summery_report_data: fuel.summery_report_data,
    };
};

function mapDispatchToProps(dispatch) {
    return {
        getFuelSummeryReport
    };
}

const FuelSummeryReport = Form.create({ name: 'asset-mileage-report' })(SummeryReport);
export default connect(mapStateToProps, mapDispatchToProps())(FuelSummeryReport);
